export const getRCLeftMenuData = [
  {
    heading: 'Manage Deposits',
    icon: 'icmn icmn-library',
    disabled: true,
  },
  {
    divider: true,
  },
  {
    title: 'Trades',
    key: 'trades',
    url: '/trades',
    icon: 'icmn icmn-credit-card',
    roles: ['user'],
  },
  {
    title: 'Report',
    key: 'reports',
    url: '/reports',
    icon: 'icmn icmn-stats-bars',
    roles: ['user'],
  },
]

export const getCCLeftMenuData = [
  {
    heading: 'Currency Accounts',
    icon: 'icmn icmn-library',
    disabled: true,
  },
  {
    divider: true,
  },
  {
    title: 'Balances',
    key: 'balances',
    url: '/account-balances',
    icon: 'icmn icmn-credit-card',
    roles: ['user'],
  },
  {
    title: 'New Payment',
    key: 'newDigitalPayment',
    url: '/new-payment',
    icon: 'fa fa-exchange',
  },
  {
    heading: 'Settings',
    icon: 'icmn icmn-cog',
    disabled: true,
  },
  {
    divider: true,
  },
  {
    title: 'Profile',
    key: 'profile',
    url: '/user-profile',
    icon: 'lnr lnr-user',
    roles: ['user'],
  },
]

export default { getRCLeftMenuData, getCCLeftMenuData }
